<template>
  <div id="main-fs">
    <div id="security-check">
      <TopHeader></TopHeader>
      <div class="main-box flex-row-c">
        <!--左边-->
        <div class="left-chart-container">
          <div class="left-top">
            <leftTableChart/>
          </div>
          <div class="left-bottom"></div>
        </div>
        <!-- 中间-->
        <div class="center-main-container">
          <!--          <centerTop></centerTop>-->
          <div class="top center-top-bar flex-row-sb">
            <img class="center-top-bar__wing center-top-bar__wing--left" src="~@/assets/large/center-top-r.png" alt="">
            <span class="tiem center-top-bar__time">{{ currentDate }}</span>
            <img class="center-top-bar__wing center-top-bar__wing--right" src="~@/assets/large/center-top-l.png" alt="">
          </div>
          <centerMap></centerMap>
          <centerButtom></centerButtom>
        </div>
        <!-- 右边-->
        <div class="right-main-container">
          <rightTableChart></rightTableChart>
        </div>
      </div>
    </div>

    <div class="full-screen-box">
      <MyScreenful/>
    </div>

  </div>
</template>

<script>

import TopHeader from "./components/topHeader";
import leftTableChart from "./components/leftTableChart";
import centerButtom from "./components/centerButtom";
import centerMap from "./components/centerMap";
import rightTableChart from "./components/rightTableChart";
import MyScreenful from "./components/MyScreenful";
import { LS3_CHART_COMPACT_CLASS } from "@/utils/ls3ChartCompact";


let time = null
export default {
  name: "LargeScreenV3",
  components: {
    TopHeader,
    leftTableChart,
    centerButtom,
    centerMap,
    rightTableChart,
    MyScreenful,
  },
  data() {
    return {
      fullscreen: false,
      refresh_page_polling: null,
      currentDate: "",
    };
  },
  created() {
    this.refresh_polling();
    this.currentDate = this.$utils.RetnW() + '  ' + this.$utils.getDate();
    time = setInterval(() => {
      this.currentDate = this.$utils.RetnW() + '  ' + this.$utils.getDate();
    }, 1000);
  },
  beforeDestroy() {
    document.documentElement.classList.remove(LS3_CHART_COMPACT_CLASS)
    clearInterval(this.refresh_page_polling)
    clearInterval(time);
  },
  mounted() {
    /** 供 ECharts 等子组件感知大屏 V3，统一缩小画布字号 */
    document.documentElement.classList.add(LS3_CHART_COMPACT_CLASS)
  },
  methods: {
    refresh_polling() {
      var self = this
      this.refresh_page_polling = setInterval(() => {
        self.refresh_page()
      }, 1000 * 60 * 30)
    },
    refresh_page() {
      this.$forceUpdate();
      this.$router.go(0);
      console.log('refreshme...')
    },
    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen
    },
  }
}
;
</script>

<style lang="scss">
/* 大屏 V3：主框架视觉（仅本页） */
$ls3-panel-edge: rgba(96, 252, 178, 0.22);

#main-fs {
  /* 整页唯一纵向滚动条，不在左/中/右分栏内各自滚动 */
  position: relative;
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* 全屏按钮：固定视口右上角，随整页滚动仍可见 */
.full-screen-box {
  position: fixed;
  top: clamp(10px, 1.8vh, 20px);
  right: clamp(12px, 2.5vw, 40px);
  left: auto;
  bottom: auto;
  width: auto;
  height: auto;
  max-width: none;
  margin: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0;
  pointer-events: none;
  z-index: 5200;

  > * {
    pointer-events: auto;
  }
}

/* 中栏顶栏：时间居中、两侧装饰翼 */
.center-top-bar {
  flex-shrink: 0;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: 10px 8px 14px;
  margin-bottom: 4px;
  box-sizing: border-box;

  &__wing {
    width: clamp(56px, 7vw, 88px);
    height: auto;
    object-fit: contain;
    opacity: 0.92;
    filter: drop-shadow(0 0 8px rgba(104, 216, 254, 0.25));
  }

  &__wing--left {
    flex-shrink: 0;
  }

  &__wing--right {
    flex-shrink: 0;
  }

  &__time {
    flex: 1;
    min-width: 0;
    margin: 0 12px !important;
    text-align: center;
    font-size: clamp(17px, 1.35vw, 22px);
    font-weight: 600;
    letter-spacing: 0.12em;
    color: #eaf8ff;
    text-shadow:
      0 0 20px rgba(104, 216, 254, 0.45),
      0 1px 2px rgba(0, 0, 0, 0.55);
    white-space: nowrap;
  }
}

#security-check {
  /* 随内容增高，由 #main-fs 统一滚动 */
  flex: 0 0 auto;
  min-height: 100vh;
  min-height: 100dvh;
  color: #fff;
  background:
    radial-gradient(ellipse 120% 80% at 50% 0%, rgba(22, 58, 90, 0.35) 0%, transparent 55%),
    url("~@/assets/large/bg.png") no-repeat center center;
  background-size: cover;
  box-shadow: inset 0 0 120px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  position: relative;

  &::before {
    content: "";
    position: fixed;
    inset: 0;
    pointer-events: none;
    background: linear-gradient(
      180deg,
      rgba(8, 12, 32, 0.15) 0%,
      transparent 28%,
      transparent 72%,
      rgba(8, 12, 32, 0.35) 100%
    );
    z-index: 0;
  }

  > * {
    position: relative;
    z-index: 1;
  }

  .main-box {
    flex: 0 0 auto;
    min-width: 0;
    /* 三栏等高：行高由最高列决定（一般为左侧内容最多）。中间列用内部 flex 把地图区撑满，避免仅背景被拉高 */
    &.flex-row-c {
      justify-content: flex-start;
      align-items: stretch;
      align-content: stretch;
      width: 100%;
    }
    /* 减少左右外边距，让三栏更贴近视口、侧栏内容可铺满各自盒子 */
    padding: 10px 4px 14px;
    display: flex;
    gap: 8px;
    box-sizing: border-box;

    .left-chart-container {
      width: 22%;
      min-width: 260px;
      padding: 0;
      align-self: stretch;
      display: flex;
      flex-direction: column;
      border-radius: 6px;
      border: 1px solid $ls3-panel-edge;
      background: linear-gradient(
        145deg,
        rgba(8, 18, 42, 0.42) 0%,
        rgba(12, 28, 52, 0.28) 100%
      );
      box-shadow:
        0 0 0 1px rgba(255, 255, 255, 0.04) inset,
        0 12px 40px rgba(0, 0, 0, 0.35);
      overflow: visible;

      .left-top {
        flex: 0 0 auto;
        overflow: visible;
      }

      .left-bottom {
        flex-shrink: 0;
      }
    }

    .center-main-container {
      flex: 1 1 0;
      min-width: 0;
      /* 列被拉高时允许子项 flex:1 正确分配高度 */
      min-height: 0;
      display: flex;
      flex-direction: column;
      gap: 10px;
      align-self: stretch;
      overflow: visible;
      border-radius: 6px;
      border: 1px solid $ls3-panel-edge;
      background: linear-gradient(
        160deg,
        rgba(8, 20, 48, 0.38) 0%,
        rgba(10, 24, 44, 0.22) 100%
      );
      box-shadow:
        0 0 0 1px rgba(255, 255, 255, 0.03) inset,
        0 16px 48px rgba(0, 0, 0, 0.32);
      padding: 8px 4px 10px;
      box-sizing: border-box;
    }

    .right-main-container {
      width: 25%;
      min-width: 300px;
      align-self: stretch;
      display: flex;
      flex-direction: column;
      align-items: stretch;
      border-radius: 6px;
      border: 1px solid $ls3-panel-edge;
      background: linear-gradient(
        145deg,
        rgba(8, 18, 42, 0.42) 0%,
        rgba(12, 28, 52, 0.28) 100%
      );
      box-shadow:
        0 0 0 1px rgba(255, 255, 255, 0.04) inset,
        0 12px 40px rgba(0, 0, 0, 0.35);
      overflow: visible;
      box-sizing: border-box;
      /* 侧栏内边距为 0，图表与绿框贴齐，避免两侧大块留白 */
      padding: 0;
    }
  }
}

.el-icon-fullscreen {
  content: url("~@/assets/svgs/full_screen.svg");
}
</style>
